import { Component, DestroyRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { ApiClientService } from '../../services/api-client.service';
import { TenantClientService } from '../../services/tenant-client.service';
import { getDefaultLogo } from '../../utils/default-logo.util';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SignupComponent implements OnInit {

  state: 'login' | 'processing' | 'invite-used' | 'error' = 'login';
  logo = getDefaultLogo();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private apiClient: ApiClientService,
    private tenantClient: TenantClientService,
    private destroyRef: DestroyRef
  ) { }

  ngOnInit(): void {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      const tenantCode = params['tenantCode'];
      const subject = params['subject'];
      const token = params['token'];

      this.auth.isAuthenticated$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(isAuthenticated => {
        if (isAuthenticated) {
          this.state = 'processing';
          this.apiClient.acceptInvitation(tenantCode, subject, token).subscribe({
            next: () => {
              this.router.navigate([`/${tenantCode}`]);
            },
            error: (error) => {
              this.tenantClient.getUserProfile(tenantCode).subscribe({
                next: () => this.router.navigate([`/${tenantCode}`]),
                error: () => {
                  console.error('Error accepting invitation:', error);
                  this.state = (error.status === 409 || error.status === 410) ? 'invite-used' : 'error';
                }
              });
            }
          });
        } else {
          this.state = 'login';
        }
      });
    });
  }

  loginWithMicrosoft(): void {
    this.auth.loginWithRedirect({
      authorizationParams: { connection: 'windowslive' },
      appState: { target: this.router.url }
    });
  }

  loginWithGoogle(): void {
    this.auth.loginWithRedirect({
      authorizationParams: { connection: 'google-oauth2' },
      appState: { target: this.router.url }
    });
  }

  loginWithEmail(): void {
    this.auth.loginWithRedirect({
      authorizationParams: { connection: 'email' },
      appState: { target: this.router.url }
    });
  }
}
